import { appDatasetsPath } from './constants';

export const getPath = (segments: string[]): string => {
  const url = segments.join('/');
  return url.toString();
};

export const getDatasetPath = (datasetId: string, tenantId: string): string => {
  return getPath(['', 'o', tenantId, appDatasetsPath, datasetId]);
};

export default getPath;
